<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div
          class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100"
        >
          <span class="nav-link" href="javascript:void(0)">
            Lyric Videos <span class="badge-pro badge-primary fw-bold px-2 py-1">PRO</span>
          </span>
          <div class="ml-auto">
            <button type="button" @click="newLyricVideo()" class="btn btn-gradient">{{ $t('new_video') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <div class="text-right mb-3 pr-1">
        {{ $t('videos_remaining_month') }} <b>{{ remainingVideos }}</b>
      </div>
      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-spin text-muted"></i>
      </div>
      <div class="card" v-if="!loading && lyricvideos.length">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Video</th>
                <th>{{ $t('status') }}</th>
                <th>{{ $t('created') }}</th>
                <th width="10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lyricvideos" v-bind:key="item._id">
                <td>
                  <router-link :to="`/tools/lyric-videos/${item._id}`">
                    {{ item.distribution.songs[item.song_index].title }} <span v-if="item.distribution.songs.length > 1">({{ item.distribution.title }})</span>
                  </router-link>
                </td>
                <td>
                  <span v-if="!item.transcribing && item.status === 0">
                    {{ $t('draft') }}
                  </span>
                  <span v-if="item.transcribing" class="text-primary">
                    <i class="fa fa-clock mr-1"></i> {{ $t('generating_lyrics')}}
                  </span>
                  <span v-if="item.status === 1" class="text-primary">
                    <i class="fa fa-clock mr-1"></i> {{ $t('processing')}}
                  </span>
                  <span v-if="item.status === 2" class="text-success">
                    {{ $t('created')}}
                  </span>
                </td>
                <td>
                  {{ moment(item.createdAt).format('LL') }}
                </td>
                <td class="text-right">
                  <a v-if="item.video_url" :href="item.video_url" target="_blank" class="btn btn-default btn-sm">
                    {{ $t('download') }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LyricVideo from '../services/lyricvideo'

export default {
  name: 'LyricVideos',
  data () {
    return {
      loading: true,
      user: {},
      lyricvideos: [],
      moment,
      remainingVideos: 0
    }
  },
  methods: {
    getRemainingVideos: function () {
      LyricVideo.getRemainingVideos().then(response => {
        this.remainingVideos = response.data.remaining
      })
    },
    newLyricVideo: function () {
      if (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite') {
        return this.$router.push('/upgrade?from=lyric-videos')
      }

      this.$router.push('/tools/lyric-videos/new')
    },
    getLyricVideos: function () {
      LyricVideo.getAll()
        .then(response => {
          this.lyricvideos = response.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created: function () {
    this.user = this.$user
    this.getLyricVideos()
    this.getRemainingVideos()

    if (this.$route.query.success_checkout) {
      this.$notify({ message: this.$t('purchase_success') }, 'success', 'fa-check')

      setTimeout(() => {
        this.getLyricVideos()
      }, 1000 * 5)
    }
  }
}
</script>

<style scoped>
.pricing-title {
  border: 2px solid white;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
}

.basic-price {
  font-size: 25px;
}
.pro-price {
  font-size: 45px;
}

.mastering-description {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/LyricVideos.vue